import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Country } from "@lookiero/sty-psp-locale";
import { Text } from "@lookiero/sty-psp-ui";
import { useScreenSize } from "@lookiero/sty-psp-ui";
import { PriceProjection } from "../../../../../../projection/price/price";
import { SizeProjection, size } from "../../../../../../projection/size/size";
import { Price } from "../../../../components/atoms/price/Price";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { style as productVariantDescriptionStyle } from "./ProductVariantDescription.style";

interface ProductVariantDescriptionProps {
  readonly brand: string;
  readonly name: string;
  readonly price: PriceProjection;
  readonly size: SizeProjection;
  readonly country: Country;
}
const ProductVariantDescription: FC<ProductVariantDescriptionProps> = ({
  brand,
  name,
  price,
  size: sizeProjection,
  country,
}) => {
  const sizeText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.ITEM_SIZE });
  const uniqueText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.ITEM_UNIQUE });

  const screenDevice = useScreenSize();
  const isDesktopScreen = screenDevice !== "S";

  const style = useMemo(() => productVariantDescriptionStyle(), []);

  return (
    <View style={[style.container, !isDesktopScreen && style.smallContainer]}>
      <View style={style.info}>
        <View style={style.content}>
          <Text level={1} style={style.brand} variant="detail">
            {brand}
          </Text>
          <Text level={1} variant="detailBold">
            {name}
          </Text>
        </View>
        <Price amount={price.amount} currency={price.currency} discountedPrice={price.discountedPrice} withPercentage />
      </View>
      <Text level={1} variant="detail">
        {`${sizeText} ${sizeProjection.unique ? uniqueText : size({ size: sizeProjection, country })}`}
      </Text>
    </View>
  );
};

export { ProductVariantDescription };
